const gridWrapper = document.querySelector('#product-grid');

function thirdViewImages() {
  if (!document.querySelector('.layout-btns-container [data-desktop="grid--6-col-desktop"]').classList.contains('active')) return;
  document
  .querySelectorAll('#product-grid .card-wrapper .color-swatch.active')
  .forEach((colorSwatch,index) => {
    if (index <7){
console.log('colorSwatch',colorSwatch)}
    const cardItem = colorSwatch.closest('.card-wrapper');
    if (!cardItem) return;

    const imgElm = cardItem.querySelector('.card__media img');
    if (!imgElm) return;

    // Save original image once
    if (cardItem.dataset.originalImage || !cardItem.dataset.originalImage) {
      cardItem.dataset.originalImage = colorSwatch.dataset.variantImage ? colorSwatch.dataset.variantImage : imgElm.src ;
      cardItem.dataset.originalSrcset = colorSwatch.dataset.variantImage ? `${colorSwatch.dataset.variantImage} 165w,${colorSwatch.dataset.variantImage} 360w,${colorSwatch.dataset.variantImage} 533w,${colorSwatch.dataset.variantImage} 720w,${colorSwatch.dataset.variantImage} 940w,${colorSwatch.dataset.variantImage} 1066w,${colorSwatch.dataset.variantImage} 1920w,` : imgElm.srcset;
    }

    const variantImage = colorSwatch.dataset.cardVariantImage; // ✅ single dataset key
    const colorName = colorSwatch.dataset.color || 'Variant Image';

    if (variantImage) {
      imgElm.src = variantImage;
      imgElm.srcset = `
        ${variantImage} 165w,
        ${variantImage} 360w,
        ${variantImage} 533w,
        ${variantImage} 720w,
        ${variantImage} 940w,
        ${variantImage} 1066w,
        ${variantImage} 1920w
      `;
      imgElm.alt = colorName;
    } else {
      // Restore original image
      imgElm.src = cardItem.dataset.originalImage;
      imgElm.srcset = cardItem.dataset.originalSrcset;
    }
  });
}

function defaultViewImages() {
   console.log('calling default view');
  if (document.querySelector('.layout-btns-container [data-desktop="grid--6-col-desktop"]').classList.contains('active')) return;
  console.log('calling 2 & 1 view');
  document
  .querySelectorAll('#product-grid .card-wrapper')
  .forEach((colorSwatch) => {

    const cardItem = colorSwatch.closest('.card-wrapper');
    if (!cardItem) return;

    const imgElm = cardItem.querySelector('.card__media img');
    if (!imgElm) return;

    if (!cardItem.dataset.originalImage) return;
    // Save original image once
    if (!cardItem.dataset.originalImage) {
      cardItem.dataset.originalImage = imgElm.src;
      cardItem.dataset.originalSrcset = imgElm.srcset || '';
    }

    const colorName = colorSwatch.dataset.color || 'Variant Image';

    // Restore original image
    imgElm.src = cardItem.dataset.originalImage;
    imgElm.srcset = cardItem.dataset.originalSrcset;

  });
}

(() => {
  const layoutBtns = document.querySelectorAll('.layout-btns-container span');
  const productGrid = document.getElementById('product-grid');
  if (!layoutBtns.length || !productGrid) return;

  layoutBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const desktopClass = btn.dataset.desktop;
      const mobileClass = btn.dataset.mobile;
      const isMobile = window.innerWidth <= 749;

      // 🧹 Remove only classes starting with "grid--"
      const toRemove = [...productGrid.classList].filter(cls => cls.startsWith('grid--'));
      productGrid.classList.remove(...toRemove);

      // 🎯 Add correct layout class
      productGrid.classList.add(isMobile ? mobileClass : desktopClass);

      // ✅ Optional: mark active button
      layoutBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      if (btn.dataset.desktop === 'grid--6-col-desktop') {
        thirdViewImages();
      
      } else {
          defaultViewImages();
      }
    });
  });

  // 🔄 Reapply correct layout when resizing (if active button exists)
  window.addEventListener('resize', () => {
    const activeBtn = document.querySelector('.layout-btns-container span.active');
    if (!activeBtn) return;

    const desktopClass = activeBtn.dataset.desktop;
    const mobileClass = activeBtn.dataset.mobile;
    const isMobile = window.innerWidth <= 749;

    const toRemove = [...productGrid.classList].filter(cls => cls.startsWith('grid--'));
    productGrid.classList.remove(...toRemove);

    productGrid.classList.add(isMobile ? mobileClass : desktopClass);
  });
})();

if (typeof Ajaxinate !== 'undefined' && gridWrapper) {
  const endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    loadingText: 'Loading...',
    method: "scroll",
    callback: function() {
      initCardSwatches();
      initAtcButtons();
      handleProductCardMouseLeave();
      thirdViewImages();
      defaultViewImages();
       // 🆕 New: Reinitialize VenoBox after 2 seconds (for newly loaded modals)
      setTimeout(() => {
        // Flag to ensure click handler is added only once globally
        if (!window.venoboxInitialized) {
          window.venoboxInitialized = true;

          // Add global click handler for closing modals (runs only once)
          document.addEventListener('click', function(event) {
            if (
              event.target.classList.contains('baadmay-popup-close') || 
              event.target.closest('.baadmay-popup-close')
            ) {
              // Assuming venobox is globally accessible; close it
              if (window.venoboxInstance) {
                window.venoboxInstance.close();
                console.log("VenoBox closed.");
                
                // Hide the modal container
                var modalContainer = document.querySelector('.vbox-overlay');
                if (modalContainer) {
                  modalContainer.style.display = 'none'; // Hide the modal container
                  console.log("Modal container hidden.");
                }
              }
            }
          });
        }

        // Reinitialize VenoBox for new elements (store instance globally for access)
        window.venoboxInstance = new VenoBox({
          selector: '.baadmay-modal',
          closeColor: '#000',
          closeBackground: 'transparent',
          overlayColor: 'rgba(0,0,0,.75)',
          overlayClose: false,
          customClass: 'baadmay-modal-container',
        });
        console.log("VenoBox reinitialized after infinite scroll.");
      }, 2000); // 2-second delay
    }
  });
}